module.exports = __webpack_public_path__ + "img/step7.8c65fd6a.png";